import createAxiosClient from "../utils/api-utils";

class AdminApi {
  constructor() {
    this.client = createAxiosClient();
  }

  async listUsers(limit) {
    const params = limit ? { params: { limit } } : {};
    return await this.client.get("/admin/users", params);
  }

  /**
   * Import data (CSV rows) - expects server endpoint to accept JSON array of rows
   */
  async importData(payload) {
    // If caller passes a string, send as text/csv; otherwise send JSON { rows }
    if (typeof payload === 'string') {
      return await this.client.post('/admin/import', payload, { headers: { 'Content-Type': 'text/csv' }, skipLoader: false });
    }

    return await this.client.post('/admin/import', { rows: payload });
  }

  async listUnverifiedUsers() {
    return await this.client.get('/admin/users/unverified');
  }

  async approveUser(userId) {
    return await this.client.post(`/admin/users/${userId}/approve`);
  }

  async deactivateUser(userId, reason) {
    return await this.client.post(`/admin/users/${userId}/deactivate`, { reason });
  }

  async activateUser(userId) {
    return await this.client.post(`/admin/users/${userId}/activate`);
  }

  async resetUserPassword(userId, newPassword) {
    return await this.client.post(`/admin/users/${userId}/reset-password`, { newPassword });
  }

  async listEnquiries() {
    return await this.client.get('/admin/enquiries');
  }

  async updateEnquiryStatus(enquiryId, status) {
    return await this.client.patch(`/admin/enquiries/${enquiryId}`, { status });
  }
}

export default AdminApi = new AdminApi();
